export default __webpack_public_path__ + "static/media/MysqlIcon.fbc227f1.png";